import { createSlice } from "@reduxjs/toolkit";
import getTeleServicePrice from "../../../rtk-apis/Setting/getTeleServicePrice";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const getTeleServicePriceSlice = createSlice({
    name: "getTeleServicePriceSlice",
    initialState,
    reducers: {
        clearGetTeleServicePriceState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTeleServicePrice.pending, (state) => {
                state.loading = true;
            })
            .addCase(getTeleServicePrice.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.status = payload.status;
                state.result = payload;
                state.msg = payload.msg;
            })
            .addCase(getTeleServicePrice.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
                state.error = payload;
            });
    },
});

export default getTeleServicePriceSlice.reducer;
export const { clearGetTeleServicePriceState } = getTeleServicePriceSlice.actions;
